export const options = {
    top: [
        { type: 'NoHair' },
        { type: 'Eyepatch',  },
        { type: 'Hat'},
        { type: 'Hijab'},
        { type: 'Turban'},
        { type: 'WinterHat1', hatColor: ['Black', 'Blue01', 'Blue02', 'Blue03', 'Gray01', 'Gray02', 'Heather', 'PastelBlue', 'PastelGreen', 'PastelOrange', 'PastelRed', 'PastelYellow', 'Pink', 'Red', 'White'] },
        { type: 'WinterHat2', hatColor: ['Black', 'Blue01', 'Blue02', 'Blue03', 'Gray01', 'Gray02', 'Heather', 'PastelBlue', 'PastelGreen', 'PastelOrange', 'PastelRed', 'PastelYellow', 'Pink', 'Red', 'White'] },
        { type: 'WinterHat3', hatColor: ['Black', 'Blue01', 'Blue02', 'Blue03', 'Gray01', 'Gray02', 'Heather', 'PastelBlue', 'PastelGreen', 'PastelOrange', 'PastelRed', 'PastelYellow', 'Pink', 'Red', 'White'] },
        { type: 'WinterHat4', hatColor: ['Black', 'Blue01', 'Blue02', 'Blue03', 'Gray01', 'Gray02', 'Heather', 'PastelBlue', 'PastelGreen', 'PastelOrange', 'PastelRed', 'PastelYellow', 'Pink', 'Red', 'White'] },
        { type: 'LongHairBigHair', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'LongHairBob', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'LongHairBun', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'LongHairCurly', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'LongHairCurvy', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'LongHairDreads', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'LongHairFrida'},
        { type: 'LongHairFro', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'LongHairFroBand', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'LongHairMiaWallace', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'LongHairNotTooLong', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'LongHairShavedSides'},
        { type: 'LongHairStraight', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'LongHairStraight2', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'LongHairStraightStrand', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'ShortHairDreads01', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'ShortHairDreads02', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'ShortHairFrizzle', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'ShortHairShaggyMullet', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'ShortHairShortCurly', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'ShortHairShortFlat', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'ShortHairShortRound', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'ShortHairShortWaved', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'ShortHairSides', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray'] },
        { type: 'ShortHairTheCaesar', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray']  },
        { type: 'ShortHairTheCaesarSidePart', hairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'PastelPink', 'Platinum', 'Red', 'SilverGray']  }
      ],
      accessories: [
        { type: 'Blank' },
        { type: 'Kurt' },
        { type: 'Prescription01' },
        { type: 'Prescription02' },
        { type: 'Round' },
        { type: 'Sunglasses' },
        { type: 'Wayfarers' }
    ],
    eyes: [
      { type: 'Default' },
      { type: 'Close' },
      { type: 'Cry' },
      { type: 'Dizzy' },
      { type: 'EyeRoll' },
      { type: 'Happy' },
      { type: 'Hearts' },
      { type: 'Side' },
      { type: 'Squint' },
      { type: 'Surprised' },
      { type: 'Wink' },
      { type: 'WinkWacky' }
    ],
    
      clothe: [
        { type: 'BlazerShirt'},
        { type: 'BlazerSweater'},
        { type: 'CollarSweater', clotheColor: ['Black', 'Blue01', 'Blue02', 'Blue03', 'Gray01', 'Gray02', 'Heather', 'PastelBlue', 'PastelGreen', 'PastelOrange', 'PastelRed', 'PastelYellow', 'Pink', 'Red', 'White'] },
        { type: 'GraphicShirt', clotheColor: ['Black', 'Blue01', 'Blue02', 'Blue03', 'Gray01', 'Gray02', 'Heather', 'PastelBlue', 'PastelGreen', 'PastelOrange', 'PastelRed', 'PastelYellow', 'Pink', 'Red', 'White']},
        { type: 'Hoodie', clotheColor: ['Black', 'Blue01', 'Blue02', 'Blue03', 'Gray01', 'Gray02', 'Heather', 'PastelBlue', 'PastelGreen', 'PastelOrange', 'PastelRed', 'PastelYellow', 'Pink', 'Red', 'White'] },
        { type: 'Overall', clotheColor: ['Black', 'Blue01', 'Blue02', 'Blue03', 'Gray01', 'Gray02', 'Heather', 'PastelBlue', 'PastelGreen', 'PastelOrange', 'PastelRed', 'PastelYellow', 'Pink', 'Red', 'White'] },
        { type: 'ShirtCrewNeck', clotheColor: ['Black', 'Blue01', 'Blue02', 'Blue03', 'Gray01', 'Gray02', 'Heather', 'PastelBlue', 'PastelGreen', 'PastelOrange', 'PastelRed', 'PastelYellow', 'Pink', 'Red', 'White'] },
        { type: 'ShirtScoopNeck', clotheColor: ['Black', 'Blue01', 'Blue02', 'Blue03', 'Gray01', 'Gray02', 'Heather', 'PastelBlue', 'PastelGreen', 'PastelOrange', 'PastelRed', 'PastelYellow', 'Pink', 'Red', 'White'] },
        { type: 'ShirtVNeck', clotheColor: ['Black', 'Blue01', 'Blue02', 'Blue03', 'Gray01', 'Gray02', 'Heather', 'PastelBlue', 'PastelGreen', 'PastelOrange', 'PastelRed', 'PastelYellow', 'Pink', 'Red', 'White'] },
    ],
    eyebrows: [
      { type: 'Angry' },
      { type: 'AngryNatural' },
      { type: 'Default' },
      { type: 'DefaultNatural' },
      { type: 'FlatNatural' },
      { type: 'RaisedExcited' },
      { type: 'RaisedExcitedNatural' },
      { type: 'SadConcerned' },
      { type: 'SadConcernedNatural' },
      { type: 'UnibrowNatural' },
      { type: 'UpDown' },
      { type: 'UpDownNatural' }
    ],
    
    
    facialHair: [
      { type: 'Blank' },
      { type: 'BeardLight', facialHairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'Platinum', 'Red'] },
      { type: 'BeardMajestic', facialHairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'Platinum', 'Red'] },
      { type: 'BeardMedium', facialHairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'Platinum', 'Red'] },
      { type: 'MoustacheFancy', facialHairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'Platinum', 'Red'] },
      { type: 'MoustacheMagnum', facialHairColor: ['Auburn', 'Black', 'Blonde', 'BlondeGolden', 'Brown', 'BrownDark', 'Platinum', 'Red'] },
    ],
    
    mouth: [
      { type: 'Concerned' },
      { type: 'Default' },
      { type: 'Disbelief' },
      { type: 'Eating' },
      { type: 'Grimace' },
      { type: 'Sad' },
      { type: 'ScreamOpen' },
      { type: 'Serious' },
      { type: 'Smile' },
      { type: 'Tongue' },
      { type: 'Twinkle' },
      { type: 'Vomit' }
    ],
    skin: [
      { color: 'Tanned' },
      { color: 'Yellow' },
      { color: 'Pale' },
      { color: 'Light' },
      { color: 'Brown' },
      { color: 'DarkBrown' },
      { color: 'Black' }
    ],
    
    
    };